var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#EAA61F",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49474"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    d: "M13.1,16H2.9c-1,0-2-.5-2.5-1.4-.5-.9-.6-2-.1-2.9L5.4,1.6C5.9.6,6.9,0,8,0c1.1,0,2.1.6,2.6,1.6l5.1,10.1c.5.9.4,2-.1,2.9-.5.9-1.5,1.4-2.5,1.4ZM7.2,5.6v7.4h1.6v-7.4h-1.6ZM8,2.8c-.2,0-.5,0-.6.2-.2.2-.3.4-.3.7,0,.3,0,.5.3.7.2.1.4.2.6.2.2,0,.4,0,.6-.2.2-.2.3-.4.3-.7,0-.3,0-.5-.3-.7-.2-.1-.4-.2-.6-.2h0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.147ba6e691122ffcbb8e0895840d1e65.svg";
export { ForwardRef as ReactComponent };